module.exports = __webpack_public_path__ + "static/media/Piercing-mouth-labret.a22c0844.png";